import React from "react";
import { Box, Typography, Button, SvgIcon, Link } from "@mui/material";

const StopBullyingBanner = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
        fontSize: "14px",
        backgroundColor: "#f5f5f5",
        padding: "20px",
        borderRadius: "100px",
        textAlign: "center",
      }}>
      <Link
        href="https://stopbullying.kz"
        target="_blank"
        sx={{ display: "block", marginBottom: "16px" }}>
        <img
          src="https://rvtk.bkogov.kz/images/stopbullying.svg"
          alt="stopbullying logo"
          style={{ width: "232px", height: "82px" }}
        />
      </Link>
      <Box>
        <Typography
          variant="h6"
          sx={{ fontSize: "20px", marginBottom: "8px" }}
          className="stopbullying-title">
          ИС «Komek Stop Bullying»
        </Typography>
        <Typography
          variant="h5"
          sx={{ fontSize: "24px", color: "red", marginBottom: "16px" }}
          className="stopbullying-title stopbullying-title--red">
          Остановим буллинг вместе!
        </Typography>
      </Box>

      {/* Example placeholder SVG */}
      <SvgIcon
        sx={{ width: 100, height: 100, marginBottom: "16px" }}
        viewBox="0 0 100 100">
        <rect x="0" y="0" width="100" height="100" fill="transparent"></rect>
        <g transform="scale(4)">
          <g transform="translate(0,0)">
            <path
              fillRule="evenodd"
              d="M8 0L8 1L9 1L9 2L10 2L10 3L11 3L11 1L13 1L13 2L12 2L12 4L11 4L11 5L10 5L10 4L9 4L9 5L10 5L10 8L9 8L9 6L8 6L8 8L9 8L9 9L7 9L7 8L6 8L6 9L5 9L5 8L3 8L3 9L5 9L5 11L9 11L9 13L10 13L10 12L11 12L11 13L13 13L13 11L14 11L14 16L13 16L13 17L11 17L11 16L12 16L12 15L13 15L13 14L11 14L11 16L10 16L10 15L9 15L9 14L8 14L8 13L7 13L7 12L5 12L5 13L3 13L3 11L4 11L4 10L2 10L2 8L0 8L0 10L2 10L2 13L0 13L0 17L1 17L1 15L2 15L2 17L3 17L3 16L4 16L4 17L5 17L5 16L4 16L4 14L6 14L6 15L7 15L7 16L6 16L6 17L8 17L8 18L9 18L9 20L8 20L8 22L10 22L10 23L8 23L8 25L9 25L9 24L11 24L11 20L10 20L10 19L12 19L12 21L13 21L13 22L12 22L12 23L16 23L16 22L14 22L14 21L17 21L17 22L19 22L19 21L21 21L21 16L22 16L22 18L24 18L24 19L23 19L23 22L20 22L20 23L17 23L17 24L16 24L16 25L19 25L19 24L21 24L21 25L22 25L22 24L24 24L24 25L25 25L25 20L24 20L24 19L25 19L25 18L24 18L24 16L25 16L25 14L24 14L24 13L25 13L25 10L24 10L24 9L25 9L25 8L24 8L24 9L19 9L19 8L18 8L18 9L17 9L17 4L16 4L16 3L17 3L17 1L16 1L16 2L15 2L15 0L14 0L14 1L13 1L13 0L11 0L11 1L9 1L9 0ZM14 3L14 4L15 4L15 9L16 9L16 11L15 11L15 10L14 10L14 8L13 8L13 7L14 7L14 6L13 6L13 7L12 7L12 5L13 5L13 4L12 4L12 5L11 5L11 7L12 7L12 9L10 9L10 10L9 10L9 11L10 11L10 10L12 10L12 11L13 11L13 10L14 10L14 11L15 11L15 13L16 13L16 12L17 12L17 14L16 14L16 15L15 15L15 16L14 16L14 18L12 18L12 19L14 19L14 20L13 20L13 21L14 21L14 20L15 20L15 19L16 19L16 18L15 18L15 16L17 16L17 14L18 14L18 16L19 16L19 15L20 15L20 16L21 16L21 15L20 15L20 13L21 13L21 14L23 14L23 13L24 13L24 12L21 12L21 10L20 10L20 11L19 11L19 13L18 13L18 12L17 12L17 11L18 11L18 10L19 10L19 9L18 9L18 10L17 10L17 9L16 9L16 4L15 4L15 3ZM6 9L6 10L7 10L7 9ZM12 9L12 10L13 10L13 9ZM22 10L22 11L24 11L24 10ZM6 13L6 14L7 14L7 13ZM2 14L2 15L3 15L3 14ZM23 15L23 16L24 16L24 15ZM9 16L9 17L10 17L10 16ZM17 17L17 20L20 20L20 17ZM14 18L14 19L15 19L15 18ZM18 18L18 19L19 19L19 18ZM21 23L21 24L22 24L22 23ZM12 24L12 25L15 25L15 24ZM0 0L0 7L7 7L7 0ZM1 1L1 6L6 6L6 1ZM2 2L2 5L5 5L5 2ZM18 0L18 7L25 7L25 0ZM19 1L19 6L24 6L24 1ZM20 2L20 5L23 5L23 2ZM0 18L0 25L7 25L7 18ZM1 19L1 24L6 24L6 19ZM2 20L2 23L5 23L5 20Z"
              fill="#000000"></path>
          </g>
        </g>
      </SvgIcon>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}>
        <Button
          variant="contained"
          sx={{
            background: "black",
            maxHeight: 50,
          }}
          href="https://play.google.com/store/apps/details?id=kz.stopbullying"
          target="_blank"
          startIcon={
            <SvgIcon>
              <path
                d="M16.6857 1.57361L15.4982 3.18298C17.3549 4.0312 18.6942 5.61156 18.8472 7.45498H6.18401C6.33596 5.61156 7.64514 4.03214 9.50175 3.18298L8.31434 1.57361C8.25297 1.45658 8.28414 1.33955 8.37571 1.28057C8.46727 1.22159 8.58903 1.25155 8.6806 1.33955L9.89821 3.03693C10.6901 2.74389 11.5727 2.56882 12.5166 2.56882C13.4605 2.56882 14.3128 2.74483 15.1349 3.03693L16.3525 1.33955C16.4139 1.25155 16.5357 1.22253 16.6262 1.28057C16.7168 1.33862 16.748 1.45658 16.6876 1.57361H16.6857ZM9.83587 5.75761C10.2313 5.75761 10.5362 5.46457 10.5362 5.08446C10.5362 4.73337 10.2313 4.41131 9.83587 4.41131C9.47058 4.41131 9.1355 4.73337 9.1355 5.08446C9.1355 5.46457 9.47058 5.75761 9.83587 5.75761ZM15.2547 5.75761C15.6502 5.75761 15.9551 5.46457 15.9551 5.08446C15.9551 4.73337 15.6502 4.41131 15.2547 4.41131C14.8894 4.41131 14.5544 4.73337 14.5544 5.08446C14.5544 5.46457 14.8894 5.75761 15.2547 5.75761ZM2.5 15.0899V9.67758C2.5 8.91643 3.10881 8.27325 3.93094 8.27325C4.72287 8.27325 5.33168 8.91737 5.33168 9.67758V15.0899C5.33168 15.8801 4.72287 16.4942 3.93094 16.4942C3.10881 16.4942 2.5 15.8801 2.5 15.0899ZM19.6381 15.0899V9.67758C19.6381 8.91643 20.2771 8.27325 21.0691 8.27325C21.861 8.27325 22.5 8.91737 22.5 9.67758V15.0899C22.5 15.8801 21.861 16.4942 21.0691 16.4942C20.2771 16.4942 19.6381 15.8801 19.6381 15.0899ZM6.2142 18.2206V8.30227H18.8774V18.2206C18.8774 18.8058 18.3601 19.3029 17.7513 19.3029H16.5035V22.3747C16.5035 23.1358 15.8645 23.75 15.0726 23.75C14.2806 23.75 13.6416 23.1358 13.6416 22.3747V19.3029H11.4197V22.3747C11.4197 23.1358 10.8109 23.75 10.019 23.75C9.19686 23.75 8.58806 23.1358 8.58806 22.3747V19.3029H7.30908C6.73047 19.3029 6.2142 18.8058 6.2142 18.2206Z"
                fill="#fff"
              />
            </SvgIcon>
          }>
          Скачать для Android
        </Button>
        <Button
          variant="contained"
          sx={{
            background: "black",
            maxHeight: 50,
          }}
          href="https://apps.apple.com/us/app/stop-bullying/id6464056749"
          target="_blank"
          startIcon={
            <SvgIcon>
              <path
                d="M17.3111 0C17.3693 0 17.4274 0 17.4889 0C17.6316 1.76305 16.9587 3.0804 16.1408 4.03438C15.3383 4.98178 14.2395 5.90063 12.4621 5.76121C12.3436 4.0234 13.0176 2.80376 13.8344 1.85197C14.5918 0.964958 15.9806 0.175647 17.3111 0Z"
                fill="#fff"></path>
              <path
                d="M22.6913 18.3507C22.6913 18.3682 22.6913 18.3836 22.6913 18.4001C22.1918 19.9128 21.4794 21.2093 20.6099 22.4125C19.8162 23.5048 18.8436 24.9747 17.1069 24.9747C15.6062 24.9747 14.6094 24.0098 13.0714 23.9834C11.4445 23.9571 10.5498 24.7903 9.06227 25C8.89211 25 8.72195 25 8.55509 25C7.46279 24.8419 6.58126 23.9768 5.93905 23.1974C4.04536 20.8942 2.58201 17.9192 2.30975 14.1121C2.30975 13.7388 2.30975 13.3667 2.30975 12.9934C2.42502 10.2687 3.74896 8.05338 5.50872 6.97974C6.43745 6.40889 7.71418 5.92257 9.13582 6.13993C9.74509 6.23434 10.3675 6.44292 10.9131 6.64931C11.4302 6.84801 12.0768 7.2004 12.6894 7.18174C13.1043 7.16966 13.5171 6.9534 13.9354 6.8008C15.1605 6.35839 16.3615 5.85121 17.9445 6.08943C19.847 6.37705 21.1973 7.22235 22.0316 8.52653C20.4222 9.55077 19.1499 11.0943 19.3672 13.7301C19.5604 16.1243 20.9524 17.5251 22.6913 18.3507Z"
                fill="#fff"></path>
            </SvgIcon>
          }>
          Скачать для iOS
        </Button>
      </Box>
    </Box>
  );
};

export default StopBullyingBanner;
